// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdminPanel_page__CG8qU {
  min-height: 100vh;
  padding: 18px;
  background: #ecf0f1;
  font-family: Arial, sans-serif;
  color: #2c3e50;
}

.AdminPanel_hero__IFw3h {
  max-width: 1360px;
  margin: 0 auto 16px;
  padding: 16px 18px;
  border-radius: 12px;
  background: linear-gradient(120deg, #2c3e50 0%, #34495e 65%, #3a5064 100%);
  color: #ecf0f1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 14px;
  box-shadow: 0 6px 18px rgba(44, 62, 80, 0.22);
}

.AdminPanel_badge__7XVwL {
  margin: 0;
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  opacity: 0.75;
}

.AdminPanel_title__kSpht {
  margin: 6px 0 0;
  font-size: clamp(1.35rem, 2.5vw, 1.9rem);
}

.AdminPanel_subtitle__51CSy {
  margin: 6px 0 0;
  font-size: 0.9rem;
  opacity: 0.9;
}

.AdminPanel_topActions__uMPQh {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.AdminPanel_grid__TQGBn {
  max-width: 1360px;
  margin: 0 auto;
  display: grid;
  gap: 14px;
  grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));
}

.AdminPanel_card__5buCc {
  max-width: 1360px;
  margin: 12px auto 0;
  background: #ffffff;
  border: 1px solid #d8e1e8;
  border-radius: 12px;
  box-shadow: 0 3px 10px rgba(44, 62, 80, 0.08);
  padding: 14px;
}

.AdminPanel_card__5buCc h2 {
  margin: 0 0 10px;
  font-size: 1.05rem;
  color: #1f2f3d;
}

.AdminPanel_sectionLead__wy8f5 {
  margin: 0 0 8px;
  color: #516576;
  line-height: 1.45;
}

.AdminPanel_inlineForm__ylEB1,
.AdminPanel_filterRow__VX8Sq {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.AdminPanel_inlineForm__ylEB1 {
  align-items: center;
}

.AdminPanel_inlineField__bQgzW {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 220px;
  flex: 1 1 220px;
}

.AdminPanel_inlineField__bQgzW span {
  color: #355061;
  font-size: 0.86rem;
  font-weight: 600;
}

.AdminPanel_checkboxWrap__VUn8K {
  margin-top: 10px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 8px;
}

.AdminPanel_deviceConfigItem__3qBNy {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.AdminPanel_checkboxItem__nCJGQ {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 8px;
  background: #f8fbfd;
  border: 1px solid #d9e3ec;
}

.AdminPanel_activationBox__YckXZ {
  margin-top: 10px;
  padding: 10px;
  border-radius: 8px;
  border: 1px dashed #3498db;
  background: #eaf5fb;
  word-break: break-all;
}

.AdminPanel_rowActions__qbxqe {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.AdminPanel_inlineCheck__\\+U5Xm {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 38px;
  padding: 0 6px;
}

input,
select {
  min-height: 38px;
  padding: 8px 10px;
  border: 1px solid #c8d5e1;
  border-radius: 8px;
  background: #ffffff;
  color: #243746;
  font-size: 0.92rem;
}

input:focus,
select:focus {
  outline: none;
  border-color: #3498db;
  box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.2);
}

.AdminPanel_primaryButton__s-jrZ,
.AdminPanel_secondaryButton__AkyQe,
.AdminPanel_ghostButton__Xy-n9 {
  border: none;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 0.88rem;
  cursor: pointer;
  transition: background-color 0.18s ease, transform 0.08s ease;
}

.AdminPanel_primaryButton__s-jrZ {
  background: #3498db;
  color: #ffffff;
}

.AdminPanel_secondaryButton__AkyQe {
  background: #e6edf3;
  color: #2c3e50;
  border: 1px solid #cedae4;
}

.AdminPanel_ghostButton__Xy-n9 {
  background: transparent;
  color: #2c3e50;
  border: 1px solid #c8d5e1;
}

.AdminPanel_activeTab__m\\+1JL {
  background: #1abc9c;
  color: #ffffff;
  border-color: #16a085;
}

.AdminPanel_primaryButton__s-jrZ:hover,
.AdminPanel_secondaryButton__AkyQe:hover,
.AdminPanel_ghostButton__Xy-n9:hover {
  transform: translateY(-1px);
}

.AdminPanel_sectionHeader__uKWAm,
.AdminPanel_sectionHeaderMulti__YjC7l {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  flex-wrap: wrap;
}

.AdminPanel_sectionHeader__uKWAm {
  align-items: center;
}

.AdminPanel_tableWrap__rKBEy {
  width: 100%;
  overflow-x: auto;
  border-radius: 10px;
  border: 1px solid #d8e1e8;
}

.AdminPanel_table__9JImX {
  width: 100%;
  border-collapse: collapse;
  min-width: 760px;
}

.AdminPanel_table__9JImX thead tr {
  background: #34495e;
  color: #ecf0f1;
}

.AdminPanel_table__9JImX th,
.AdminPanel_table__9JImX td {
  padding: 10px 12px;
  text-align: left;
  border-bottom: 1px solid #e5ecf2;
  vertical-align: middle;
}

.AdminPanel_table__9JImX tbody tr:nth-child(even) {
  background: #f8fbfd;
}

.AdminPanel_table__9JImX tbody tr:hover {
  background: #edf4fa;
}

.AdminPanel_sortable__SUCCO {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.AdminPanel_emptyRow__UJ2i7 {
  text-align: center;
  color: #7f8c8d;
  padding: 12px;
}

.AdminPanel_loading__7frHL {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Arial, sans-serif;
  color: #2c3e50;
}

.AdminPanel_modalForm__fSD6A {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 12px;
}

.AdminPanel_modalField__QJIlG {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.AdminPanel_modalField__QJIlG label {
  color: #355061;
  font-size: 0.86rem;
  font-weight: 600;
}

.AdminPanel_modalError__FmVa- {
  margin: 0;
  color: #c0392b;
  font-size: 0.9rem;
}

@media (max-width: 768px) {
  .AdminPanel_page__CG8qU {
    padding: 10px;
  }

  .AdminPanel_hero__IFw3h {
    padding: 12px;
    border-radius: 10px;
  }

  .AdminPanel_card__5buCc {
    padding: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AdminPanel.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,0EAA0E;EAC1E,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,6CAA6C;AAC/C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,SAAS;EACT,2DAA2D;AAC7D;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;EAC7C,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,2DAA2D;EAC3D,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;;;EAGE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,6DAA6D;AAC/D;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;;;EAGE,2BAA2B;AAC7B;;AAEA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".page {\n  min-height: 100vh;\n  padding: 18px;\n  background: #ecf0f1;\n  font-family: Arial, sans-serif;\n  color: #2c3e50;\n}\n\n.hero {\n  max-width: 1360px;\n  margin: 0 auto 16px;\n  padding: 16px 18px;\n  border-radius: 12px;\n  background: linear-gradient(120deg, #2c3e50 0%, #34495e 65%, #3a5064 100%);\n  color: #ecf0f1;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 14px;\n  box-shadow: 0 6px 18px rgba(44, 62, 80, 0.22);\n}\n\n.badge {\n  margin: 0;\n  font-size: 11px;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  opacity: 0.75;\n}\n\n.title {\n  margin: 6px 0 0;\n  font-size: clamp(1.35rem, 2.5vw, 1.9rem);\n}\n\n.subtitle {\n  margin: 6px 0 0;\n  font-size: 0.9rem;\n  opacity: 0.9;\n}\n\n.topActions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.grid {\n  max-width: 1360px;\n  margin: 0 auto;\n  display: grid;\n  gap: 14px;\n  grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));\n}\n\n.card {\n  max-width: 1360px;\n  margin: 12px auto 0;\n  background: #ffffff;\n  border: 1px solid #d8e1e8;\n  border-radius: 12px;\n  box-shadow: 0 3px 10px rgba(44, 62, 80, 0.08);\n  padding: 14px;\n}\n\n.card h2 {\n  margin: 0 0 10px;\n  font-size: 1.05rem;\n  color: #1f2f3d;\n}\n\n.sectionLead {\n  margin: 0 0 8px;\n  color: #516576;\n  line-height: 1.45;\n}\n\n.inlineForm,\n.filterRow {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.inlineForm {\n  align-items: center;\n}\n\n.inlineField {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 220px;\n  flex: 1 1 220px;\n}\n\n.inlineField span {\n  color: #355061;\n  font-size: 0.86rem;\n  font-weight: 600;\n}\n\n.checkboxWrap {\n  margin-top: 10px;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n  gap: 8px;\n}\n\n.deviceConfigItem {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.checkboxItem {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 10px;\n  border-radius: 8px;\n  background: #f8fbfd;\n  border: 1px solid #d9e3ec;\n}\n\n.activationBox {\n  margin-top: 10px;\n  padding: 10px;\n  border-radius: 8px;\n  border: 1px dashed #3498db;\n  background: #eaf5fb;\n  word-break: break-all;\n}\n\n.rowActions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.inlineCheck {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-height: 38px;\n  padding: 0 6px;\n}\n\ninput,\nselect {\n  min-height: 38px;\n  padding: 8px 10px;\n  border: 1px solid #c8d5e1;\n  border-radius: 8px;\n  background: #ffffff;\n  color: #243746;\n  font-size: 0.92rem;\n}\n\ninput:focus,\nselect:focus {\n  outline: none;\n  border-color: #3498db;\n  box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.2);\n}\n\n.primaryButton,\n.secondaryButton,\n.ghostButton {\n  border: none;\n  border-radius: 8px;\n  padding: 8px 12px;\n  font-size: 0.88rem;\n  cursor: pointer;\n  transition: background-color 0.18s ease, transform 0.08s ease;\n}\n\n.primaryButton {\n  background: #3498db;\n  color: #ffffff;\n}\n\n.secondaryButton {\n  background: #e6edf3;\n  color: #2c3e50;\n  border: 1px solid #cedae4;\n}\n\n.ghostButton {\n  background: transparent;\n  color: #2c3e50;\n  border: 1px solid #c8d5e1;\n}\n\n.activeTab {\n  background: #1abc9c;\n  color: #ffffff;\n  border-color: #16a085;\n}\n\n.primaryButton:hover,\n.secondaryButton:hover,\n.ghostButton:hover {\n  transform: translateY(-1px);\n}\n\n.sectionHeader,\n.sectionHeaderMulti {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 10px;\n  flex-wrap: wrap;\n}\n\n.sectionHeader {\n  align-items: center;\n}\n\n.tableWrap {\n  width: 100%;\n  overflow-x: auto;\n  border-radius: 10px;\n  border: 1px solid #d8e1e8;\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 760px;\n}\n\n.table thead tr {\n  background: #34495e;\n  color: #ecf0f1;\n}\n\n.table th,\n.table td {\n  padding: 10px 12px;\n  text-align: left;\n  border-bottom: 1px solid #e5ecf2;\n  vertical-align: middle;\n}\n\n.table tbody tr:nth-child(even) {\n  background: #f8fbfd;\n}\n\n.table tbody tr:hover {\n  background: #edf4fa;\n}\n\n.sortable {\n  cursor: pointer;\n  user-select: none;\n}\n\n.emptyRow {\n  text-align: center;\n  color: #7f8c8d;\n  padding: 12px;\n}\n\n.loading {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: Arial, sans-serif;\n  color: #2c3e50;\n}\n\n.modalForm {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 12px;\n}\n\n.modalField {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.modalField label {\n  color: #355061;\n  font-size: 0.86rem;\n  font-weight: 600;\n}\n\n.modalError {\n  margin: 0;\n  color: #c0392b;\n  font-size: 0.9rem;\n}\n\n@media (max-width: 768px) {\n  .page {\n    padding: 10px;\n  }\n\n  .hero {\n    padding: 12px;\n    border-radius: 10px;\n  }\n\n  .card {\n    padding: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `AdminPanel_page__CG8qU`,
	"hero": `AdminPanel_hero__IFw3h`,
	"badge": `AdminPanel_badge__7XVwL`,
	"title": `AdminPanel_title__kSpht`,
	"subtitle": `AdminPanel_subtitle__51CSy`,
	"topActions": `AdminPanel_topActions__uMPQh`,
	"grid": `AdminPanel_grid__TQGBn`,
	"card": `AdminPanel_card__5buCc`,
	"sectionLead": `AdminPanel_sectionLead__wy8f5`,
	"inlineForm": `AdminPanel_inlineForm__ylEB1`,
	"filterRow": `AdminPanel_filterRow__VX8Sq`,
	"inlineField": `AdminPanel_inlineField__bQgzW`,
	"checkboxWrap": `AdminPanel_checkboxWrap__VUn8K`,
	"deviceConfigItem": `AdminPanel_deviceConfigItem__3qBNy`,
	"checkboxItem": `AdminPanel_checkboxItem__nCJGQ`,
	"activationBox": `AdminPanel_activationBox__YckXZ`,
	"rowActions": `AdminPanel_rowActions__qbxqe`,
	"inlineCheck": `AdminPanel_inlineCheck__+U5Xm`,
	"primaryButton": `AdminPanel_primaryButton__s-jrZ`,
	"secondaryButton": `AdminPanel_secondaryButton__AkyQe`,
	"ghostButton": `AdminPanel_ghostButton__Xy-n9`,
	"activeTab": `AdminPanel_activeTab__m+1JL`,
	"sectionHeader": `AdminPanel_sectionHeader__uKWAm`,
	"sectionHeaderMulti": `AdminPanel_sectionHeaderMulti__YjC7l`,
	"tableWrap": `AdminPanel_tableWrap__rKBEy`,
	"table": `AdminPanel_table__9JImX`,
	"sortable": `AdminPanel_sortable__SUCCO`,
	"emptyRow": `AdminPanel_emptyRow__UJ2i7`,
	"loading": `AdminPanel_loading__7frHL`,
	"modalForm": `AdminPanel_modalForm__fSD6A`,
	"modalField": `AdminPanel_modalField__QJIlG`,
	"modalError": `AdminPanel_modalError__FmVa-`
};
export default ___CSS_LOADER_EXPORT___;
